import type { LmsAdapter, MappingFormData } from './types';

export const tutorlmsAdapter: LmsAdapter = {
  lmsType: 'tutorlms',
  displayName: 'TutorLMS',
  shortDescription: 'Koble TutorLMS-kurs (WordPress) til en godkjent studieplan',
  colors: {
    bg: 'bg-purple-50',
    border: 'border-purple-200',
    badge: 'bg-purple-100 text-purple-800',
    primary: 'bg-purple-600 hover:bg-purple-700'
  },
  courseIdField: {
    label: 'TutorLMS kurs-ID (WordPress post-ID)',
    placeholder: 'F.eks. 456',
    helpText: 'WordPress post-ID for kurset (vises i WP-admin URL etter post=...)',
    inputType: 'number',
    validate: (v) => /^\d+$/.test(v.trim()) ? null : 'TutorLMS kurs-ID må være et heltall',
    parse: (v) => parseInt(v.trim(), 10)
  },
  courseNameField: {
    label: 'Kursnavn i TutorLMS',
    placeholder: 'Eksakt tittel som vist i TutorLMS',
    required: true
  },
  endpoints: {
    listMappingsForMember: (mid) => `/api/tutorlms/mappings/member/${mid}`,
    listMappingsForIntegration: (iid) => `/api/tutorlms/mappings/${iid}`,
    createMappingForMember: (mid) => `/api/tutorlms/mappings/member/${mid}`,
    updateMapping: (id) => `/api/tutorlms/mappings/${id}`,
    deleteMapping: (id) => `/api/tutorlms/mappings/${id}`,
    listCoursesByMember: (mid) => `/api/tutorlms/courses/member/${mid}`
  },
  normalizeCourseList: (rawCourses) =>
    (rawCourses as Array<{ id: number; title: string; slug?: string; status?: string }>)
      .map(c => ({
        id: String(c.id),
        name: c.title,
        secondary: [c.slug, c.status && c.status !== 'publish' ? c.status : null].filter(Boolean).join(' · ')
      })),
  buildCreateBody: (data: MappingFormData) => ({
    // Backend forventer tutor_course_id/_title (pre-eksisterende DB-skjema fra fase-2-tiden)
    tutor_course_id: parseInt(data.lmsCourseId, 10),
    tutor_course_title: data.lmsCourseName,
    study_plan_id: data.studyPlanId,
    assessment_type: data.assessmentType,
    no_self_assessment_confirmed: data.noSelfAssessmentConfirmed,
    controlled_conditions_confirmed: data.controlledConditionsConfirmed,
    module_codes: data.moduleCodes.length > 0 ? data.moduleCodes : null,
    ects_credits: data.ectsCredits ?? null,
    certificate_title: data.certificateTitle ?? null,
    certificate_description: data.certificateDescription ?? null,
    framework_rationale: data.frameworkRationale || undefined,
    has_rubric: Boolean(data.hasRubric)
  }),
  buildUpdateBody: (data: MappingFormData) => ({
    tutor_course_title: data.lmsCourseName,
    assessment_type: data.assessmentType,
    no_self_assessment_confirmed: data.noSelfAssessmentConfirmed,
    controlled_conditions_confirmed: data.controlledConditionsConfirmed,
    module_codes: data.moduleCodes.length > 0 ? data.moduleCodes : null,
    ects_credits: data.ectsCredits ?? null,
    certificate_title: data.certificateTitle ?? null,
    certificate_description: data.certificateDescription ?? null,
    framework_rationale: data.frameworkRationale || undefined,
    has_rubric: Boolean(data.hasRubric)
  })
};
